import Intervention from "../../insurance/Intervention";
import {Chip} from "@mui/material";

export default class InterventionUtils {

    static getCurrentStepAsArray() {
        return [
            Intervention.STEP_INITIALIZED,
            Intervention.STEP_QUOTATION_APPOINTMENT,
            Intervention.STEP_TRAVEL,
            Intervention.STEP_PICTURE_BEFORE,
            Intervention.STEP_QUOTATION,
            Intervention.STEP_QUOTATION_FAIRFAIR_VALIDATION,
            Intervention.STEP_QUOTATION_PRESCRIBER_VALIDATION,
            Intervention.STEP_QUOTATION_SIGNATURE,
            Intervention.STEP_WORKS_APPOINTMENT,
            Intervention.STEP_WORKS,
            Intervention.STEP_PICTURE_AFTER,
            Intervention.STEP_REPORT_COMPLETION,
            Intervention.STEP_REPORT_COMPLETION_SIGNATURE
        ];
    }


    static getCurrentStepAsText(currentStep) {
        switch (currentStep) {
            case Intervention.STEP_INITIALIZED:
                return "RDV devis";
            case Intervention.STEP_QUOTATION_APPOINTMENT:
                return "DEP";
            case Intervention.STEP_TRAVEL:
                return "Photo AV";
            case Intervention.STEP_PICTURE_BEFORE:
                return "Devis";
            case Intervention.STEP_QUOTATION:
                return "Val devis";
            case Intervention.STEP_QUOTATION_FAIRFAIR_VALIDATION:
                return "Val devis";
            case Intervention.STEP_QUOTATION_PRESCRIBER_VALIDATION:
                return "Val devis";
            case Intervention.STEP_QUOTATION_SIGNATURE:
                return "RDV travaux";
            case Intervention.STEP_WORKS_APPOINTMENT:
                return "Inter";
            case Intervention.STEP_WORKS:
                return "Photo AP";
            case Intervention.STEP_PICTURE_AFTER:
                return "Compte rendu";
            case Intervention.STEP_REPORT_COMPLETION:
                return "PV";
            case Intervention.STEP_REPORT_COMPLETION_SIGNATURE:
                return "Terminée";
        }

        return "NR";
    }

    static getCurrentStepAsBadge(currentStep, size = "medium") {
        let color = "info";

        switch (currentStep) {
            case Intervention.STEP_INITIALIZED:
                color = `error`;
                break;
            case Intervention.STEP_QUOTATION_APPOINTMENT:
                color = `error`;
                break;
            case Intervention.STEP_TRAVEL:
                color = `info`;
                break;
            case Intervention.STEP_PICTURE_BEFORE:
                color = `info`;
                break;
            case Intervention.STEP_QUOTATION:
                color = `error`;
                break;
            case Intervention.STEP_QUOTATION_FAIRFAIR_VALIDATION:
                color = `error`;
                break;
            case Intervention.STEP_QUOTATION_PRESCRIBER_VALIDATION:
                color = `error`;
                break;
            case Intervention.STEP_QUOTATION_SIGNATURE:
                color = `error`;
                break;
            case Intervention.STEP_WORKS_APPOINTMENT:
                color = `warning`;
                break;
            case Intervention.STEP_WORKS:
                color = `info`;
                break;
            case Intervention.STEP_PICTURE_AFTER:
                color = `info`;
                break;
            case Intervention.STEP_REPORT_COMPLETION:
                color = `info`;
                break;
            case Intervention.STEP_REPORT_COMPLETION_SIGNATURE:
                color = `success`;
                break;
        }

        return <Chip label={InterventionUtils.getCurrentStepAsText(currentStep)} color={color} size={size}/>;
    }

    static getCurrentStepAsTextForCompany(currentStep) {
        switch (currentStep) {
            case Intervention.STEP_INITIALIZED:
                return "1/13 Prise de rendez-vous devis";
            case Intervention.STEP_QUOTATION_APPOINTMENT:
                return "2/13 Déplacement";
            case Intervention.STEP_TRAVEL:
                return "3/13 Photos avant travaux";
            case Intervention.STEP_PICTURE_BEFORE:
                return "4/13 Réalisation du devis";
            case Intervention.STEP_QUOTATION:
                return "5/13 Validation FairFair du devis";
            case Intervention.STEP_QUOTATION_FAIRFAIR_VALIDATION:
                return "6/13 Validation prescripteur du devis";
            case Intervention.STEP_QUOTATION_PRESCRIBER_VALIDATION:
                return "7/13 Signature du devis";
            case Intervention.STEP_QUOTATION_SIGNATURE:
                return "8/13 Prise de rendez-vous travaux";
            case Intervention.STEP_WORKS_APPOINTMENT:
                return "9/13 Réalisation des travaux";
            case Intervention.STEP_WORKS:
                return "10/13 Photos après travaux";
            case Intervention.STEP_PICTURE_AFTER:
                return "11/13 Compte rendu d'intervention";
            case Intervention.STEP_REPORT_COMPLETION:
                return "12/13 Signature du procés verbal";
            case Intervention.STEP_REPORT_COMPLETION_SIGNATURE:
                return "13/13 Terminée";
        }

        return "NR";
    }
}
